export const css = {
	root: 'AdIqf9dB',
	hideCountdownBlock: '_1NHonxa8',
	' _key': 'exam-countdown/exam-countdown'
};

export default css;
